import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class Pmsversion extends Model {
  [Type] = 'pmsversion' as const;

  // PMS name + version
  @attr('string') declare displayName: string;
  // PMS name
  @attr('string') declare pmsName: string;
}
